import React, { useEffect, useMemo, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions, getGradeOptions, GradeLevelOptions, GradeOptions } from "../../../../../../../../_helpers/Helpers";
import * as actions from "../../../../../_redux/private-notices/PrivateNoticesAction";
import { useSectionsUIContext } from "../SectionsUIContext";

const prepareFilter = (queryParams, values) => {
  let { gradeLevel, grade, name, courseId } = values;
  const noticeId = queryParams.filter.noticeId;
  const newQueryParams = { ...queryParams };
  const filter = { noticeId, gradeLevel, grade, name, courseId };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function SectionsFilter() {
  const [gradeOptions, setGradeOptions] = useState(FilterOptions.concat(GradeOptions));

  // Sections UI Context
  const sectionsUIContext = useSectionsUIContext();
  const sectionsUIProps = useMemo(() => {
    return {
      setQueryParams: sectionsUIContext.setQueryParams,
      queryParams: sectionsUIContext.queryParams,
    };
  }, [sectionsUIContext]);

  const dispatch = useDispatch();
  const { courses } = useSelector(
    (state) => ({
      courses: state.privateNotices.filterList
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getCourses());
  }, [dispatch]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(sectionsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, sectionsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      sectionsUIProps.setQueryParams(newQueryParams);
    }
  };
  
  const gradeLevelOptions = FilterOptions.concat(GradeLevelOptions)
  const courseOptions = FilterOptions.concat(courses);

  return (
    <Formik
      initialValues={{        
        name: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
          <div className="col-lg-2">
              <CustomSelect 
                options={gradeLevelOptions}
                value={values.gradeLevel}
                placeholder="Sınıf Düzeyi"
                onBlur={handleBlur}
                onChange={e => {
                  if (e.value === undefined) {
                    setGradeOptions(FilterOptions.concat(GradeOptions));
                    setFieldValue("grade", undefined);

                  } else {
                    const options = getGradeOptions(e.value);

                    if (options.length === 1) {
                      setGradeOptions(options);
                      setFieldValue("grade", options[0].value);

                    } else {
                      setGradeOptions(FilterOptions.concat(options));
                      if (!options.map(option => option.value).includes(values.grade)) setFieldValue("grade", undefined);
                    }
                  }
                  setFieldValue("gradeLevel", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf Düzeyi</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={gradeOptions}
                value={values.grade}
                placeholder="Sınıf"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("grade", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf</b>
              </small>
            </div>            
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Şube"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Şube</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={courseOptions}
                value={values.courseId}
                placeholder="Ders"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("courseId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Ders</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}